export default __webpack_public_path__ + "static/media/payment-m.892771d7.png";